import { PropsWithChildren, ReactNode } from 'react';
import { Tooltip } from './Tooltip';

interface TableTooltipProps extends PropsWithChildren {
  tooltip: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const TableTooltip = ({
  children,
  tooltip,
  open,
  onOpenChange,
}: TableTooltipProps) => (
  <Tooltip
    open={open}
    onOpenChange={onOpenChange}
    content={tooltip}
    TooltipTriggerProps={{ asChild: true }}
    TooltipContentProps={{
      withArrow: true,
      variant: 'secondary',
      className: 'max-w-75',
      TooltipArrowProps: { className: 'fill-secondary' },
    }}
  >
    {children}
  </Tooltip>
);
